var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlySmoothBillingEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80002 32C4.80002 32 7.90002 29.1 9.40002 32C9.40002 32 9.90002 80.9 9.70002 89.1C9.70002 89.1 6.70002 90.5 5.00002 89.1C5.00002 89.1 4.50002 39.1 4.80002 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 32C12.6 32 15.7 29.1 17.2 32C17.2 32 17.7 80.9 17.4 89.1C17.4 89.1 14.5 90.5 12.7 89.1C12.7 89.1 12.3 39.1 12.6 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 32C20.3 32 23.5 29.1 25 32C25 32 25.4 80.9 25.2 89.1C25.2 89.1 22.3 90.5 20.5 89.1C20.5 89.1 20.1 39.1 20.3 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1 32C28.1 32 31.3 29.1 32.8 32C32.8 32 33.2 80.9 33 89.1C33 89.1 30.1 90.5 28.3 89.1C28.3 89.1 27.9 39.1 28.1 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9 32C35.9 32 39 29.1 40.5 32C40.5 32 41 80.9 40.8 89.1C40.8 89.1 37.9 90.5 36.1 89.1C36.1 89.1 35.7 39.1 35.9 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7 32C43.7 32 46.8 29.1 48.3 32C48.3 32 48.8 80.9 48.6 89.1C48.6 89.1 45.6 90.5 43.9 89.1C43.9 89.1 43.4 39.1 43.7 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67 32C67 32 70.2 29.1 71.7 32C71.7 32 72.1 80.9 71.9 89.1C71.9 89.1 69 90.5 67.2 89.1C67.2 89.1 66.8 39.1 67 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8 32C74.8 32 77.9 29.1 79.4 32C79.4 32 79.9 80.9 79.7 89.1C79.7 89.1 76.8 90.5 75 89.1C75 89.1 74.6 39.1 74.8 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6 32C82.6 32 85.7 29.1 87.2 32C87.2 32 87.7 80.9 87.5 89.1C87.5 89.1 84.5 90.5 82.8 89.1C82.8 89.1 82.3 39.1 82.6 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4 32C90.4 32 93.5 29.1 95 32C95 32 95.5 80.9 95.2 89.1C95.2 89.1 92.3 90.5 90.5 89.1C90.5 89.1 90.1 39.1 90.4 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 32C51.5 32 54.6 29.1 56.1 32C56.1 32 56.6 80.9 56.3 89.1C56.3 89.1 53.4 90.5 51.6 89.1C51.6 89.1 51.2 39.1 51.5 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2 32C59.2 32 62.4 29.1 63.9 32C63.9 32 64.3 80.9 64.1 89.1C64.1 89.1 61.2 90.5 59.4 89.1C59.4 89.1 59 39.1 59.2 32Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89998 95.7H5.59998V95.2H6.29998C6.39499 95.0518 6.43069 94.8733 6.39998 94.7V92.8H6.99998V94.7C7.01208 94.8324 6.991 94.9658 6.93862 95.088C6.88624 95.2102 6.80422 95.3174 6.69998 95.4C6.64122 95.5041 6.55272 95.5882 6.44582 95.6417C6.33892 95.6951 6.21849 95.7154 6.09998 95.7H5.89998Z",
    fill: "#00A997"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 95.7H45.3V95.2C45.3 95.2265 45.3105 95.2519 45.3293 95.2707C45.348 95.2895 45.3735 95.3 45.4 95.3H45.6C45.8 95.3 45.9 95.3 45.9 95.2C45.995 95.0518 46.0307 94.8733 46 94.7V92.8H46.6V94.7C46.6121 94.8324 46.591 94.9658 46.5386 95.088C46.4862 95.2102 46.4042 95.3174 46.3 95.4C46.2412 95.5041 46.1527 95.5882 46.0458 95.6417C45.9389 95.6951 45.8185 95.7154 45.7 95.7H45.5Z",
    fill: "#00A997"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4 95.7H53.2V95.2C53.2 95.3 53.3 95.3 53.4 95.3H54C54.0432 95.1354 54.0766 94.9685 54.1 94.8V92.8H54.6V94.7C54.6074 94.9484 54.5376 95.193 54.4 95.4C54.3124 95.4981 54.2043 95.5758 54.0833 95.6277C53.9624 95.6795 53.8315 95.7042 53.7 95.7H53.4Z",
    fill: "#00A997"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 92.8H15.1V93.3H14V94H15.1V94.5H14V95.7H13.4V92.8Z",
    fill: "#00A997"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 92.8H21.5L22.2 94.4L22.9 92.8H23.6L23.8 95.7H23.2V93.5L22.4 95H21.9L21.2 93.5V95.7H20.7L20.8 92.8Z",
    fill: "#00A997"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 95.7H28.8L29.8 92.8H30.4L31.5 95.7H30.9L30.7 95H29.5L29.3 95.7ZM29.7 94.6H30.5L30.1 93.4L29.7 94.6Z",
    fill: "#00A997"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61 95.7H60.5L61.5 92.8H62.1L63.2 95.7H62.6L62.4 95H61.2L61 95.7ZM61.4 94.6H62.2L61.8 93.4L61.4 94.6Z",
    fill: "#00A997"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 93.3C69.4638 93.3406 69.4363 93.3881 69.4191 93.4397C69.4019 93.4913 69.3954 93.5458 69.4 93.6C69.4 93.7 69.4 93.7 69.5 93.8L69.9 94H70.3C70.3 94.1 70.4 94.1 70.5 94.2L70.7 94.4V94.7C70.7 94.9 70.7 95 70.6 95.1L70.4 95.4L70.1 95.6H69.2L68.7 95.4L69 95L69.3 95.2H69.7C70 95.2 70.2 95.1 70.2 94.9C70.2 94.7 70.2 94.8 70.1 94.7H69.3C69.247 94.7 69.1961 94.6789 69.1586 94.6414C69.1211 94.6039 69.1 94.5531 69.1 94.5L68.9 94.3C68.9 94.2 68.8 94.1 68.8 94C68.8 93.9 68.9 93.8 68.9 93.7L69.1 93.4L69.4 93.2H70.3L70.7 93.6L70.2 93.8C70.1422 93.7487 70.1063 93.6771 70.1 93.6H69.5V93.3Z",
    fill: "#00A997"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3 93.7C76.3418 93.5047 76.4473 93.3288 76.6 93.2L77.1 92.9H78.2L78.7 93.2C78.796 93.2415 78.8766 93.3121 78.9304 93.4018C78.9843 93.4915 79.0086 93.5958 79 93.7C79.1225 93.8386 79.1931 94.0152 79.2 94.2C79.2092 94.3084 79.1962 94.4175 79.1618 94.5206C79.1274 94.6238 79.0724 94.7189 79 94.8C79.0086 94.9043 78.9843 95.0086 78.9304 95.0983C78.8766 95.188 78.796 95.2585 78.7 95.3L78.2 95.6H77.1L76.6 95.3L76.3 94.8C76.205 94.6519 76.1693 94.4733 76.2 94.3C76.2 94 76.2 93.8 76.3 93.7ZM76.8 94.6C76.8 94.8 76.9 94.9 77 94.9L77.3 95.1H78L78.3 94.9C78.4 94.9 78.5 94.8 78.5 94.6C78.5362 94.5594 78.5637 94.5119 78.5809 94.4603C78.5981 94.4087 78.6046 94.3542 78.6 94.3C78.6 94.1 78.6 94 78.5 93.9C78.4 93.8 78.4 93.7 78.3 93.6L78 93.4H77.3L77 93.6C76.9 93.7 76.8 93.8 76.8 93.9C76.8 94 76.7 94.1 76.7 94.3C76.6954 94.3542 76.7019 94.4087 76.7191 94.4603C76.7363 94.5119 76.7638 94.5594 76.8 94.6Z",
    fill: "#00A997"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4 92.8H84.9L86.3 94.8V92.8H86.8V95.7H86.3L84.9 93.7V95.7H84.4V92.8Z",
    fill: "#00A997"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3 92.8H93.9L94.3 93.1C94.4845 93.2183 94.6251 93.394 94.7 93.6C94.7432 93.7645 94.7766 93.9315 94.8 94.1C94.8 94.3 94.7 94.5 94.7 94.7L94.3 95.2L93.9 95.5H92.2V92.8H93.3ZM93.6 95.1L93.9 94.9C94 94.9 94.1 94.8 94.1 94.6C94.1 94.4 94.2 94.4 94.2 94.2C94.2022 94.0602 94.1677 93.9223 94.1 93.8L93.9 93.5H92.8V95.4H93.6V95.1Z",
    fill: "#00A997"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6 92.8H37.3L38 94.4L38.8 92.8H39.5V95.7H39V93.5L38.3 95H37.8L37.1 93.5V95.7H36.6V92.8Z",
    fill: "#00A997"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlySmoothBillingEnabled);
export default __webpack_public_path__ + "static/media/monthly-smooth-billing-enabled.673f446fd320bd13131576f4871d335a.svg";
export { ForwardRef as ReactComponent };